import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"margin":"0","display":"inline-block"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Chỉ cần nhập [Mã Giao Dịch] lần này vào ô [Nội dung chuyển khoản] kèm số tiền muốn nạp và chờ đợi giây lát, tiền sẽ tự động được cộng.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Là hình thức sử dụng chuyển khoản Ngân Hàng, giao dịch tự động cập nhật từ phía ngân hàng và cộng tiền trực tiếp vào tài khoản của bạn với chi phí CỰC RẺ"),
  /*#__PURE__*/_createElementVNode("li", null, "Bạn chỉ cần có một tài khoản ngân hàng bất kì (ưu tiên Techcombank, Vietcombank) là có thể sử dụng dịch vụ"),
  /*#__PURE__*/_createElementVNode("li", null, "Hỗ trợ nhiều hình thức nạp khác nhau như: eBanking, iBanking, Mobile Banking, App Banking, Ví Momo chuyển khoản liên ngân hàng, Ví ZaloPay chuyển khoản liên ngân hàng..."),
  /*#__PURE__*/_createElementVNode("li", null, "Tài khoản sẽ được tự động cộng tiền ngay sau khi phía ngân hàng của chúng tôi nhận được thông tin thanh toán")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Chỉ cần nhập đúng mã giao dịch vào phần \"Ghi chú\" hay \"Tin nhắn\",... tại màn hình chuyển của dịch vụ bạn sử dụng, hệ thống của chúng tôi sẽ tự động xử lí giao dịch sau vài giây khi nhận được thông tin thanh toán thành công"),
  /*#__PURE__*/_createElementVNode("li", null, "Mọi chi tiết xin liên hệ fanpage để được hỗ trợ")
], -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "mt-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.chargeViaEBank')
  }, {
    default: _withCtx(() => [
      false
        ? (_openBlock(), _createBlock(_component_a_skeleton, {
            key: 0,
            loading: _ctx.isLoading,
            active: ""
          }, {
            default: _withCtx(() => [
              (_ctx.transPrefix)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_ctx.transId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_a_alert, {
                            message: "Mã Giao Dịch lần này",
                            type: "info",
                            class: "mb-20"
                          }, {
                            description: _withCtx(() => [
                              _createVNode(_component_a_tag, { color: "purple" }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_SyncOutlined, {
                                    style: {"font-size":"20px","vertical-align":"baseline"},
                                    spin: ""
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_3, [
                                    _createVNode(_component_a_typography_title, {
                                      level: 2,
                                      copyable: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("X" + _toDisplayString(_ctx.transPrefix) + "X" + _toDisplayString(_ctx.transId) + "X", 1)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_collapse, {
                            activeKey: _ctx.bankAccsActiveKeys,
                            "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bankAccsActiveKeys) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_collapse_panel, {
                                key: "list",
                                header: "Thông tin chuyển khoản"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_table, {
                                    dataSource: _ctx.bankAccs,
                                    columns: _ctx.bankAccsCols,
                                    pagination: false,
                                    loading: _ctx.isFetchingBankAccs,
                                    class: "mb-20"
                                  }, {
                                    bodyCell: _withCtx(({ column, record, text }) => [
                                      (column.dataIndex === 'qr')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (record.bank_bin && record.bank_bin.length)
                                              ? (_openBlock(), _createBlock(_component_a_image, {
                                                  key: 0,
                                                  style: {"max-width":"200px"},
                                                  src: `https://img.vietqr.io/image/${record.bank_bin}-${record.account}-print.jpg?addInfo=X${_ctx.transPrefix}X${_ctx.transId}X`
                                                }, null, 8, ["src"]))
                                              : (record.qr && record.qr.length)
                                                ? (_openBlock(), _createBlock(_component_a_image, {
                                                    key: 1,
                                                    style: {"max-width":"200px"},
                                                    src: record.qr
                                                  }, null, 8, ["src"]))
                                                : _createCommentVNode("", true)
                                          ], 64))
                                        : (column.dataIndex === 'account')
                                          ? (_openBlock(), _createBlock(_component_a_typography_title, {
                                              key: 1,
                                              level: 3,
                                              copyable: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(text), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["dataSource", "columns", "loading"]),
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    size: "large",
                                    block: "",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fetchBackAccs())),
                                    loading: _ctx.isFetchingBankAccs
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Nhận thông tin Ngân Hàng chuyển khoản")
                                    ]),
                                    _: 1
                                  }, 8, ["loading"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_collapse_panel, {
                                key: "help",
                                header: "Hướng dẫn nạp"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_4,
                                  _createVNode(_component_a_image, { src: "https://i.imgur.com/PNd1H1d.png" })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_collapse_panel, {
                                key: "info",
                                header: "Giới thiệu & Lưu ý"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_typography_paragraph, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_typography_title, { level: 2 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Giới thiệu nạp thẻ qua Chuyển khoản Ngân Hàng thanh toán Tự Động")
                                        ]),
                                        _: 1
                                      }),
                                      _hoisted_5,
                                      _createVNode(_component_a_typography_title, { level: 2 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Quý khách hàng lưu ý")
                                        ]),
                                        _: 1
                                      }),
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["activeKey"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            size: "large",
                            block: "",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.genNewPayment())),
                            loading: _ctx.isGenerating
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Nhận Mã Giao Dịch mới")
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]))
                  ]))
                : (_openBlock(), _createBlock(_component_a_alert, {
                    key: 1,
                    message: "Xảy ra lỗi, vui lòng thử lại",
                    type: "warning"
                  }, {
                    description: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fetchPaymentInfo()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Thử lại")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      (_ctx.hasManagerPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_a_table, {
              dataSource: _ctx.dataSource,
              columns: _ctx.columns,
              pagination: _ctx.pagination,
              loading: _ctx.isLoadingTable,
              scroll: {x: '100%'}
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.key === 'action')
                  ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                      default: _withCtx(() => [
                        (record.status === _ctx.PaymentStatus.NOT_PAID)
                          ? (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 0,
                              title: "Huỷ giao dịch"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  danger: "",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.deletePaymentConfirm(record))
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_DeleteOutlined)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["dataSource", "columns", "pagination", "loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}